// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__H6wxp","resendInfoText":"OnGoingPaymentBox_resendInfoText__1zax1"};